// src/mockdata.js
export const employees = [
  {
    name: 'Ali Haider',
    designation: 'MEP Design Engineer',
    qualification: 'BSc Electrical Engineer',
    experience: '10 Years+',
    pec: 'ELECT/35737',
    image: '/images/members/mem1.webp',
  },
  {
    name: 'Engr.Ahmad Imdad',
    designation: 'Mechanical Engineer',
    qualification: 'BSc Mechanical Engineer',
    experience: '8 Years+',
    image: '/images/members/mem2.webp',
  },
  {
    name: 'Zeeshan Khalid',
    designation: 'MEP Draftsman',
    qualification: 'Diploma',
    experience: '10 Years+',
    image: '/images/members/mem3.webp',
  },
  {
    name: 'Shakoor Ahmad',
    designation: 'Project Engineer',
    qualification: 'Bsc Electrical Engineer',
    experience: '4 Years',
    image: '/images/members/mem4.webp',
  },
  {
    name: 'Muhammad Ahmed',
    designation: 'MEP Design Engineer',
    qualification: 'Diploma',
    experience: '2 Years+',
    image: '/images/members/mem9.webp',
  },
  {
    name: 'Engr. Muhammad Haris',
    designation: 'Electrical Engineer',
    qualification: 'BSC Engineer',
    experience: '3 Years',
    pec: 'ELECT/78671',
    image: '/images/members/mem5.webp',
  },
  {
    name: 'Sufiyan',
    designation: 'Design Engineer',
    qualification: 'BSET',
    experience: '2 Years',
    image: '/images/members/mem6.webp',
  },
  {
    name: 'Rashid Rana',
    designation: 'Draftsman',
    qualification: 'Diploma',
    experience: '2 Years+',
    image: '/images/members/mem7.webp',
  },
  {
    name: 'M. Ramzan',
    designation: 'Electrical Engineer',
    qualification: 'BSC Engineer',
    experience: '3 Years +',
    pec: 'ELECT/77919',
    image: '/images/members/mem8.webp',
  },
  {
    name: 'Sameen Alvi',
    designation: 'Design Engineer',
    qualification: 'BSC Mechanical Engineer',
    experience: '1 Year',
    image: '/images/members/mem10.webp',
    pec: 'MECH/43619',
  },
];



// Remove the old featuredProjects array and instead filter from projects

// List the IDs of the projects you want to feature
const FEATURED_IDS = [1, 2, 3]; // Update these IDs as needed

export const projects = [
  {
    id: 1,
    title: "FAISAL TOWER",
    image: "/images/projects/ZEDEM INTERNATIONAL.webp",
    category: "Commercial",
    clientName: "Faisal Town",
    work: `Complete Distribution & Backbone design
Electrical & Allied System Design
Electrical Supervision
ESE Lightning Protection
Bus Tie Duct
Procurement Proceedings`,
    location: "Islamabad",
    area: "90,000 SFT",
    load: "1.2 MW"
  },
  {
    id: 2,
    title: "GOURMET PALACES",
    image: "/images/projects/GOURMET PALACES.webp",
    category: "Residential",
    clientName: "Gourmet",
    work: `Electrical & Allied System Design
Back Bone Design
External Lighting Arrangements
Early Streamer Emission Design
Financial & Technical Documents
Home Automation
Solar System`,
    location: "Lahore",
    area: "600,000 SFT",
    load: "800 KW"
  },
  {
    id: 3,
    title: "HARMONY HEIGHTS",
    image: "/images/projects/HARMONY HEIGHTS.webp",
    category: "Commercial",
    clientName: "Capital Smart City",
    work: `Electrical & Allied System Design`,
    location: "Islamabad",
    area: "350,000 SFT",
    load: "2.5 MW"
  },
  {
    id: 4,
    title: "BA MALL",
    image: "/images/projects/BA MALL.webp",
    category: "Commercial",
    clientName: "Green Developers",
    work: `Electrical & Allied System Design
Bus Tie Duct
Dry Type Transformer
MEP Coordination`,
    location: "Quetta",
    area: "980,000 SFT",
    load: "10.5 MW"
  },
  {
    id: 5,
    title: "JAMIA MADNIA",
    image: "/images/projects/JAMIA MADNIA.webp",
    category: "Religious",
    clientName: "Faisal Town",
    work: `Complete Distribution & Backbone design
Electrical & Allied System Design
Supervision of Electrical Works`,
    location: "Islamabad",
    area: "45,000 SFT",
    load: "400 KW"
  },
  {
    id: 6,
    title: "JAMIA MASJID SAEED",
    image: "/images/projects/JAMIA MASJID SAEED.webp",
    category: "Religious",
    clientName: "Admin",
    work: `Electrical & Allied System Design`,
    location: "Lahore",
    area: "25,000 SFT",
    load: "200 KW"
  },
  {
    id: 7,
    title: "GHAWIND MOSQUE",
    image: "/images/projects/GHAWIND MOSQUE.webp",
    category: "Religious",
    clientName: "Mr. Rizwan",
    work: `Electrical & Allied System Design
Public Health System Design`,
    location: "Lahore",
    area: "20,000 SFT",
    load: "100 KW"
  },
  {
    id: 8,
    title: "METRO RAVI",
    image: "/images/projects/METRO RAVI.webp",
    category: "Commercial",
    clientName: "Metro Cash & Carry",
    work: "Fire Alarm System Design As Per NFPA Standards",
    location: "Lahore",
    area: "100,000 SFT",
    load: null
  },
  {
    id: 9,
    title: "70+ HBL BRANCHES",
    image: "/images/projects/HBL BRANCHES.webp",
    category: "Banking",
    clientName: "HBL",
    work: "Redesigning of Complete Electrical & Allied Systems",
    location: "All over Pakistan",
    area: "2,000 - 10,000 SFT",
    load: null
  },
  {
    id: 10,
    title: "TEHZEEB FOOD PROCESSING PLANT",
    image: "/images/projects/TEHZEEB FOOD PROCESSING PLANT.webp",
    category: "Industrial",
    clientName: "Tehzeeb",
    work: `Hygienic design of Electrical & Allied Systems
Illumination Design As per IES Standards
Energy Saving using Occupancy Sensors
Substation Design
Lightning Protection System`,
    location: "Lahore",
    area: "300,000 SFT",
    load: "800 KW"
  },
  {
    id: 11,
    title: "10+ BOP BRANCHES",
    image: "/images/projects/BOP BRANCHES.webp",
    category: "Banking",
    clientName: "Bank OF Punjab",
    work: "Redesigning of Complete Electrical & Allied Systems",
    location: "Lahore/Islamabad/Karachi",
    area: "2,000 SFT - 20,000 SFT",
    load: null
  },
  {
    id: 12,
    title: "15+ FAYSAL BANK BRANCHES",
    image: "/images/projects/FAYSAL BANK BRANCHES.webp",
    category: "Banking",
    clientName: "Faysal Bank",
    work: "Redesigning of Complete Electrical & Allied Systems",
    location: "Lahore/Islamabad/Karachi",
    area: "2,000 SFT - 15,000 SFT",
    load: null
  },
  {
    id: 13,
    title: "10+ MCB BANK BRANCHES",
    image: "/images/projects/MCB BANK BRANCHES.webp",
    category: "Banking",
    clientName: "MCB Bank",
    work: `Electrical & Allied Systems
Plumbing Design
AC’s Design`,
    location: "Lahore/Islamabad/other Cities",
    area: "2,000 SFT - 15,000 SFT",
    load: null
  },
  {
    id: 14,
    title: "PATIENT WELFARE SOCIETY",
    image: "/images/projects/PATIENT WELFARE SOCIETY.webp",
    category: "Healthcare",
    clientName: "Dr. Tahir",
    work: `Electrical & Allied System Design
Luminance Design Criteria as per International Standards
Bidding Documents`,
    location: "Okara",
    area: null,
    load: "150 KW"
  },
  {
    id: 15,
    title: "QURTABA SOCIETY",
    image: "/images/projects/QURTABA SOCIETY.webp",
    category: "Residential",
    clientName: "Qurtaba Society",
    work: `Electrical & Allied Works of Main Gate
Façade Illumination Design
Surveillance System
Auto Security System`,
    location: "Lahore",
    area: null,
    load: "50 KW"
  },
  {
    id: 16,
    title: "AL-RAHEEM GARDEN",
    image: "/images/projects/AL-RAHEEM GARDEN.webp",
    category: "Residential",
    clientName: "Al-Raheem Developers",
    work: `External Lighting Design
Architectural Pole Design
Street Lighting Design
Feeder Pillars Design`,
    location: "Lahore",
    area: null,
    load: null
  },
  {
    id: 17,
    title: "HBK STRIP MALL",
    image: "/images/projects/HBK STRIP MALL.webp",
    category: "Commercial",
    clientName: "Dr. Muhibullah",
    work: `Electrical & Allied System Design`,
    location: "Peshawar",
    area: "380,000 SFT",
    load: "1.6 MW"
  },
  {
    id: 18,
    title: "PAK INTERNATIONAL MEDICAL COLLEGE",
    image: "/images/projects/PAK INTERNATIONAL MEDICAL COLLEGE.webp",
    category: "Healthcare",
    clientName: "Dr. Tariq Safi",
    work: `Primary & Secondary Back Bone Design
Site Supervision
Material Procurement`,
    location: "Peshawar",
    area: "270,000 SFT",
    load: "1.5 MW"
  },
  {
    id: 19,
    title: "RED SUN TOWER",
    image: "/images/projects/RED SUN TOWER.webp",
    category: "Commercial",
    clientName: "Red Sun",
    work: `Electrical & Allied System Design`,
    location: "Faisal Hills, ISD",
    area: "800,000 SFT",
    floors: 24,
    load: "6.5 MW"
  },
  {
    id: 20,
    title: "GULBERG ARENA",
    image: "/images/projects/GULBERG ARENA.webp",
    category: "Commercial",
    clientName: "Mr. Zeeshan Ghani",
    work: `Electrical Mian Back Bone Design`,
    location: "Islamabad",
    area: "400,000 SFT",
    floors: 7,
    load: "2 MW",
    videos: ["/videos/gulbergArena.mp4"]
  },
  {
    id: 21,
    title: "BURJ ONE",
    image: "/images/projects/BURJ ONE.webp",
    category: "Residential",
    clientName: "Ajwa Developers",
    work: `Electrical & Allied System Design`,
    location: "Lahore",
    area: "550,000 SFT",
    floors: 24,
    load: "3.5 MW"
  },
  {
    id: 22,
    title: "CITY SCAPE HEIGHTS",
    image: "/images/projects/CITY SCAPE HEIGHTS.webp",
    category: "Residential",
    clientName: "Mun o Salva Developers",
    work: `Electrical & Allied System Design
Plumbing System
Fire Fighting System
AC System`,
    location: "Lahore",
    area: "300,000 SFT",
    floors: 11,
    load: "1.8 MW"
  },
  {
    id: 23,
    title: "WAHDAT AL NAJRAN KSA",
    image: "/images/projects/WAHDAT AL NAJRAN KSA.webp",
    category: "Commercial",
    clientName: "Mr. Nofal",
    work: `Electrical & Allied System Design`,
    location: "Saudi Arabia",
    area: "600,000 SFT",
    load: "5 MW"
  },
  {
    id: 24,
    title: "MALL OF SIALKOT",
    image: "/images/projects/MALL OF SIALKOT.webp",
    category: "Commercial",
    clientName: "Mr. Naveed Aslam",
    work: `Electrical & Allied System Design`,
    location: "Sialkot",
    area: "200,000 SFT",
    load: "1.5 MW"
  },
  {
    id: 25,
    title: "RAMADA GILGIT",
    image: "/images/projects/RAMADA GILGIT.webp",
    category: "Hospitality",
    clientName: "Ramada Group",
    work: `Electrical Back Bone Design`,
    location: "Gilgit",
    area: "100,000 SFT",
    load: "500 KW"
  },
  {
    id: 26,
    title: "RAMADA HUNZA",
    image: "/images/projects/RAMADA HUNZA.webp",
    category: "Hospitality",
    clientName: "Ramada Group",
    work: `Electrical Back Bone Design`,
    location: "Hunza",
    area: "80,000 SFT",
    load: "400 KW"
  },
  {
    id: 27,
    title: "GILGIT GUEST HOUSES",
    image: "/images/projects/GILGIT GUEST HOUSES.webp",
    category: "Hospitality",
    clientName: "Mr. Arif",
    work: `Electrical & Allied System Design`,
    location: "Gilgit",
    area: "50,000 SFT",
    load: "400 KW"
  },
  {
    id: 28,
    title: "FALETTI’S HOTEL AYUBIA",
    image: "/images/projects/FALETTI’S HOTEL AYUBIA.webp",
    category: "Hospitality",
    clientName: "Abdullah Developers",
    work: `Electrical & Allied System Design
Fire Fighting Design
Plumbing Design`,
    location: "Ayubia, Murree",
    area: "150,000 SFT",
    load: "800 KW"
  },
  {
    id: 29,
    title: "60L APARTMENTS",
    image: "/images/projects/60L APARTMENTS.webp",
    category: "Residential",
    clientName: "Mr. Mohsin Naqvi",
    work: "Main Back Bone Design",
    location: "Lahore",
    area: "90,000 SFT",
    load: "500 KW"
  },
  {
    id: 30,
    title: "GARRISON MARQUEE",
    image: "/images/projects/GARRISON MARQUEE.webp",
    category: "Event",
    clientName: "Mr. Shuban",
    work: "Electrical & Allied System Design",
    location: "Lahore Cantt",
    area: "60,000 SFT",
    load: "450 KW"
  },
  {
    id: 31,
    title: "TERRACE APARTMENTS",
    image: "/images/projects/TERRACE APARTMENTS.webp",
    category: "Residential",
    clientName: "Park View City, ISD",
    work: "Electrical & Allied System Design",
    location: "Islamabad",
    area: "110,000 SFT",
    load: "650 KW"
  },
  {
    id: 32,
    title: "HANNOVER MARQUEE",
    image: "/images/projects/HANNOVER MARQUEE.webp",
    category: "Event",
    clientName: "Varioline Intercool",
    work: "Electrical & Allied System Design",
    location: "Lahore",
    area: "200,000 SFT",
    load: "500 KW"
  },
  {
    id: 33,
    title: "MAAHI COMMERCIAL",
    image: "/images/projects/MAAHI COMMERCIAL.webp",
    category: "Commercial",
    clientName: "Maahi Developers",
    work: "Electrical & Allied System Design\nVRF & Split Design\nFire Fighting Design\nPublic Health Design",
    location: "Lahore",
    area: "20,000 SFT",
    load: "200 KW"
  },

  {
    id: 35,
    title: "GLORY HEIGHTS",
    image: "/images/projects/GLORY HEIGHTS.webp",
    category: "Residential",
    clientName: "Mr. Faizan",
    work: "Electrical & Allied System Design\nSplit AC's Design\nFire Fighting Design\nPublic Health Design",
    location: "Lahore",
    area: "10,000 SFT",
    load: "90 KW"
  },
 
  
  {
    id: 38,
    title: "TAKBEER HEIGHTS",
    image: "/images/projects/TAKBEER HEIGHTS.webp",
    category: "Commercial",
    clientName: "Takbeer Developers",
    work: "Electrical & Allied System Design\nVRF Design\nFire Fighting Design\nPublic Health Design",
    location: "Bahria Town, Lahore",
    area: "40,000 SFT",
    load: "400 KW"
  },

  {
    id: 40,
    title: "CHOHAN HOSPITAL",
    image: "/images/projects/CHOHAN HOSPITAL.webp",
    category: "Healthcare",
    clientName: "Dr. Chohan",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design",
    location: "Lahore",
    area: "70,000 SFT",
    load: "400 KW"
  },
 

  {
    id: 44,
    title: "130 COMMERCIAL",
    image: "/images/projects/130 COMMERCIAL.webp",
    category: "Commercial",
    clientName: "Mr. Mushtaq",
    work: "Electrical & Allied System Design\nSplit AC's Design\nFire Fighting Design\nPublic Health Design",
    location: "Lahore",
    area: "6,500 SFT",
    load: "70 KW"
  },
 
  {
    id: 46,
    title: "WAHEED COMMERCIAL",
    image: "/images/projects/WAHEED COMMERCIAL.webp",
    category: "Commercial",
    clientName: "Mr. Abdul Waheed",
    work: "Electrical & Allied System Design\nSplit AC's Design\nFire Fighting Design\nPublic Health Design",
    location: "Bahria Town, Lahore",
    area: "8,500 SFT",
    load: "100 KW"
  },
  {
    id: 47,
    title: "MSA COMMERCIAL",
    image: "/images/projects/MSA COMMERCIAL.webp",
    category: "Commercial",
    clientName: "MSA Developers",
    work: "Electrical & Allied System Design\nSplit AC's Design\nFire Fighting Design\nPublic Health Design",
    location: "Bahria Town, Lahore",
    area: "10,000 SFT",
    load: "100 KW"
  },
  {
    id: 48,
    title: "TAKBEER HEIGHTS",
    image: "/images/projects/TAKBEER HEIGHTS.webp",
    category: "Commercial",
    clientName: "Takbeer Developers",
    work: "Electrical & Allied System Design\nVRF Design\nFire Fighting Design\nPublic Health Design",
    location: "Bahria Town, Lahore",
    area: "40,000 SFT",
    load: "400 KW"
  },
  {
    id: 49,
    title: "MAAHI HEIGHTS",
    image: "/images/projects/MAAHI HEIGHTS.webp",
    category: "Commercial",
    clientName: "Maahi Developers",
    work: "Electrical & Allied System Design\nVRF Design\nFire Fighting Design\nPublic Health Design",
    location: "Bahria Town, Lahore",
    area: "35,000 SFT",
    load: "300 KW"
  },

  {
    id: 51,
    title: "DC OFFICE",
    image: "/images/projects/DC OFFICE.webp",
    category: "Office",
    clientName: "Ahmed",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design",
    location: "Lahore",
    area: "5,000 SFT",
    load: "60 KW"
  },
  {
    id: 52,
    title: "DPS WAZIRABAD",
    image: "/images/projects/DPS WAZIRABAD.webp",
    category: "Educational",
    clientName: "DPS",
    work: "Electrical & Allied System Design\nSplit AC Design\nPublic Health Design",
    location: "Wazirabad",
    area: "45,000 SFT",
    load: "200 KW"
  },
  {
    id: 53,
    title: "HASEEB COMMERCIAL",
    image: "/images/projects/HASEEB COMMERCIAL.webp",
    category: "Commercial",
    clientName: "Khurram",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design",
    location: "Lahore",
    area: "25,000 SFT",
    load: "200 KW"
  },
  {
    id: 54,
    title: "MOIZ FARM HOUSE",
    image: "/images/projects/MOIZ FARM HOUSE.webp",
    category: "Residential",
    clientName: "Mr. Moiz",
    work: "Electrical & Allied System Design\nPublic Health Design",
    location: "Lahore",
    area: "140,000 SFT",
    load: "100 KW",
    videos: ["/videos/house1.mp4"]
  },
  {
    id: 55,
    title: "TAYBA PLAZA",
    image: "/images/projects/TAYBA PLAZA.webp",
    category: "Commercial",
    clientName: "M. Faisal",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design\nFire Fighting Design",
    location: "Lahore",
    area: "60,000 SFT",
    load: "400 KW"
  },
  {
    id: 56,
    title: "LCI PHARMA",
    image: "/images/projects/LCI PHARMA.webp",
    category: "Industrial",
    clientName: "ICI/LCI",
    work: "Electrical & Allied System Design\nPublic Health Design",
    location: "Lahore",
    area: "70,000 SFT",
    load: "400 KW"
  },
  {
    id: 57,
    title: "PINE MARQUEE",
    image: "/images/projects/PINE MARQUEE.webp",
    category: "Event",
    clientName: "M. Azam",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design\nFire Fighting Design",
    location: "Lahore",
    area: "100,000 SFT",
    load: "500 KW"
  },
  {
    id: 58,
    title: "MARAKA MARQUEE",
    image: "/images/projects/MARAKA MARQUEE.webp",
    category: "Event",
    clientName: "Ch Sadiq",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC Design\nFire Fighting Design",
    location: "Lahore",
    area: "50,000 SFT",
    load: "300 KW"
  },
  {
    id: 59,
    title: "RETAIL STORE, FORT WORTH",
    image: "/images/projects/RETAIL STORE, FORT WORTH.webp",
    category: "Commercial",
    clientName: "Mr. Michael",
    work: "Electrical Design\nPlumbing Design\nHVAC Design",
    location: "USA",
    area: "18,000 SFT",
    load: "100 KW"
  },
  {
    id: 60,
    title: "ATTA NOOR TOWER",
    image: "/images/projects/ATTA NOOR TOWER.webp",
    category: "Commercial",
    clientName: "Mr. Imtiaz",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC's Design\nFire Fighting Design",
    location: "Lahore",
    area: "45,000 SFT",
    load: "300 KW"
  },
  {
    id: 61,
    title: "MOSQUE DHA PHASE-8 SECTOR-Z6",
    image: "/images/projects/MOSQUE DHA PHASE-8 SECTOR-Z6.webp",
    category: "Religious",
    clientName: "DHA",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC's Design",
    location: "Lahore",
    area: "15,000 SFT",
    load: "150 KW"
  },
  {
    id: 62,
    title: "RANACON PHARMA",
    image: "/images/projects/RANACON PHARMA.webp",
    category: "Industrial",
    clientName: "Treet",
    work: "Electrical Design",
    location: "FSD",
    area: "300,000 SFT",
    load: "1500 KVA"
  },
  {
    id: 63,
    title: "MOSQUE DHA PHASE-7 SECTOR-U",
    image: "/images/projects/MOSQUE DHA PHASE-7 SECTOR-U.webp",
    category: "Religious",
    clientName: "DHA",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC's Design",
    location: "Lahore",
    area: "15,000 SFT",
    load: "150 KW"
  },
  {
    id: 64,
    title: "HILLTOP HEIGHT KALAM",
    image: "/images/projects/HILLTOP HEIGHT KALAM.webp",
    category: "Residential",
    clientName: "Mr. Faizan",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC's Design\nFire Fighting Design",
    location: "Kalam",
    area: "55,000 SFT",
    load: "400 KW"
  },
  {
    id: 65,
    title: "MURTAZA HEIGHTS",
    image: "/images/projects/MURTAZA HEIGHTS.webp",
    category: "Residential",
    clientName: "Mr. Daniel",
    work: "Electrical & Allied System Design\nPublic Health Design\nAC's Design\nFire Fighting Design",
    location: "FSD",
    area: "55,000 SFT",
    load: "400 KW"
  },
  {
    id: 66,
    title: "500KV MAIRA SUBSTATION",
    image: "/images/projects/500KV MAIRA SUBSTATION.webp",
    category: "Utility",
    clientName: "CET",
    work: "Electrical Design",
    location: "ISD",
    area: "600,000 SFT",
    load: "500 KV"
  },
  {
    id: 67,
    title: "C-STORE PIONEER PARKWAY ARLINGTON",
    image: "/images/projects/C-STORE PIONEER PARKWAY ARLINGTON.webp",
    category: "Commercial",
    clientName: "Mr. Paul",
    work: "Electrical Design\nPlumbing Design\nHVAC Design",
    location: "USA",
    area: "20,000 SFT",
    load: "100 KW"
  },
  {
    id: 68,
    title: "500/220KV LAHORE NORTH SUBSTATION",
    image: "/images/projects/LAHORE NORTH SUBSTATION.webp",
    category: "Utility",
    clientName: "CET/WAPDA",
    work: "Electrical Design",
    location: "Lahore",
    area: "600,000 SFT",
    load: "500 KV"
  },
  {
    id: 69,
    title: "PIR CHINASI RESORT",
    image: "/images/projects/PIR CHINASI RESORT.webp",
    category: "Resort",
    clientName: "Mr. Sardar Ilyas",
    work: "Electrical Design",
    location: "Azad Kashmir",
    area: "738,000 SFT",
    load: "1 MW"
  },
  {
    id: 70,
    title: "HONDA WALTON",
    image: "/images/projects/HONDA WALTON.webp",
    category: "Commercial",
    clientName: "Sheikh Umer",
    work: "Electrical Design\nHVAC Design\nFire Fighting Design\nPlumbing Design",
    location: "LHR",
    area: "60,000 SFT",
    load: "400 KVA"
  },
  {
    id: 71,
    title: "HBL BANK D-GROUND",
    image: "/images/projects/HBL BANK D-GROUND.webp",
    category: "Commercial",
    clientName: "HBL",
    work: "Electrical Design",
    location: "FSD",
    area: "45,000 SFT",
    load: "630 KVA"
  },
  {
    id: 72,
    title: "DIAMOND FOAM PALACE",
    image: "/images/projects/DIAMOND FOAM PALACE.webp",
    category: "Industrial",
    clientName: "Mr. Bilal",
    work: "Electrical Design",
    location: "Lahore",
    area: "30,000 SFT",
    load: "150 KW"
  },
  {
    id: 73,
    title: "NAVAL GATE",
    image: "/images/projects/NAVAL GATE.webp",
    category: "Utility",
    clientName: "Mr. Ali",
    work: "MEP Design",
    location: "Karachi",
    area: "10,000 SFT",
    load: "50 KW"
  },
  {
    id: 74,
    title: "DUBAI ISLAMIC BANK",
    image: "/images/projects/DUBAI ISLAMIC BANK.webp",
    category: "Banking",
    clientName: "DIB",
    work: "Electrical Design",
    location: "LHR",
    area: "30,000 SFT",
    load: "630 KVA"
  },
  {
    id: 75,
    title: "ZARA COMMERCIAL PLAZA",
    image: "/images/projects/Commercial Plaza.webp",
    category: "Small Projects",
    location: "Lake City, Lahore",
    load: "200 KW"
  },
  {
    id: 76,
    title: "SALT & PEPPER",
    image: "/images/projects/Salt & Pepper Express.webp",
    category: "Small Projects",
    location: "Emporium Mall",
    load: "38 KW"
  },
  {
    id: 77,
    title: "TAANA BAANA",
    image: "/images/projects/Taana Baana.webp",
    category: "Small Projects",
    location: "Dolmen, Lahore",
    load: "500 SFT",
    videos: ["/videos/taanaBaana.mp4", "/videos/taanaBaana2.mp4"]
},
{
    id: 78,
    title: "Beaute’ Collection",
    image: "/images/projects/Beaute’ Collection.webp",
    category: "Small Projects",
    location: "Dolmen, Lahore",
    load: "1000 SFT",
    videos: ["/videos/beauteCollection.mp4"]
},
{
    id: 79,
    title: "PIZZA HUT",
    image: "/images/projects/Pizza Hut.webp",
    category: "Small Projects",
    location: "Gold Crest, Lahore",
    load: "900 SFT"
},
{
    id: 80,
    title: "BONBIRD",
    image: "/images/projects/Bon Bird.webp",
    category: "Small Projects",
    location: "Dolmen, Lahore",
    load: "1000 SWT"
},
{
    id: 81,
    title: "CROCS",
    image: "/images/projects/Crocs.webp",
    category: "Small Projects",
    location: "Dolmen, Lahore",
    load: "1200 SWT",
    videos: ["/videos/crocs.mp4"]
},
{
    id: 82,
    title: "PLATTER JUNCTION",
    image: "/images/projects/Platter Junction.webp",
    category: "Small Projects",
    location: "Packages Mall, Lahore",
    load: "42 KM"
},
{
    id: 83,
    title: "BRAVE GYM",
    image: "/images/projects/Brave GYM.webp",
    category: "Small Projects",
    location: "Packages Mall, Lahore",
    load: "65KM"
},
{
    id: 84,
    title: "BPO",
    image: "/images/projects/BPO.webp",
    category: "Small Projects",
    location: "Askari Tower, Lahore",
    load: "45 KW"
},
{
    id: 85,
    title: "NIVEA OFFICE",
    image: "/images/projects/Nivea Office.webp",
    category: "Small Projects",
    location: "Tricon Tower, Lahore",
    load: "50 KW"
},
{
    "id": 86,
    "title": "CH RAHMAT TRUST HOSPITAL",
    "image": "/images/projects/86.webp",
    "category": "Hospital",
    "clientName": "CH RAHMAT TRUST HOSPITAL",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "55,000 SFT",
    "load": "400 KW"
  },
  {
    "id": 87,
    "title": "LADY READING HOSPITAL BOLTON BLOCK",
    "image": "/images/projects/87.webp",
    "category": "Hospital",
    "clientName": "LADY READING HOSPITAL BOLTON BLOCK",
    "work": "Electrical & Allied System Design",
    "location": "Peshawar",
    "area": "20,000 SFT",
    "load": "200 KW"
  },
  {
    "id": 88,
    "title": "MAYO HOSPITAL MAXILLOFACIAL DEPARTMENT",
    "image": "/images/projects/88.webp",
    "category": "Hospital",
    "clientName": "MAYO HOSPITAL MAXILLOFACIAL DEPARTMENT",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "14,500 SFT",
    "load": "150 KW"
  },
  {
    "id": 89,
    "title": "DR. ALI AGHA HOSPITAL",
    "image": "/images/projects/89.webp",
    "category": "Hospital",
    "clientName": "DR. ALI AGHA HOSPITAL",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "25,000 SFT",
    "load": "300 KW"
  },
  {
    "id": 90,
    "title": "ALI HAJVERY TRUST HOSPITAL",
    "image": "/images/projects/90.webp",
    "category": "Hospital",
    "clientName": "ALI HAJVERY TRUST HOSPITAL",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "30,000 SFT",
    "load": "250 KW"
  },
  {
    "id": 91,
    "title": "AL-MUSTAFA EYE HOSPITAL, DADYAL",
    "image": "/images/projects/91.webp",
    "category": "Hospital",
    "clientName": "AL-MUSTAFA EYE HOSPITAL, DADYAL",
    "work": "Electrical & Allied System Design",
    "location": "Dadyal",
    "area": "7500 SFT",
    "load": "100 KW"
  },
  {
    "id": 92,
    "title": "RAJA COMMERCIAL",
    "image": "/images/projects/92.webp",
    "category": "Commercial",
    "clientName": "RAJA COMMERCIAL",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "90,000 SFT",
    "load": "500 KW"
  },
  {
    "id": 93,
    "title": "NISAR SYNTHETIC HEAD OFFICE",
    "image": "/images/projects/93.webp",
    "category": "Office",
    "clientName": "NISAR SYNTHETIC HEAD OFFICE",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "48,000 SFT",
    "load": "600 KW"
  },
  {
    "id": 94,
    "title": "GHURKI MEDICAL & DENTAL COLLEGE",
    "image": "/images/projects/94.webp",
    "category": "Educational/Hospital",
    "clientName": "GHURKI MEDICAL & DENTAL COLLEGE",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "350,000 SFT",
    "load": "2000 KW"
  },
  {
    "id": 95,
    "title": "KABIR MALL & RESIDENCE",
    "image": "/images/projects/95.webp",
    "category": "Commercial/Residential",
    "clientName": "KABIR MALL & RESIDENCE",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "100,000 SFT",
    "load": "1000 KW"
  },
  {
    "id": 96,
    "title": "BAJWA HOUSE",
    "image": "/images/projects/96.webp",
    "category": "Residential",
    "clientName": "BAJWA HOUSE",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "80 Kanal",
    "load": "200 KW"
  },
  {
    "id": 97,
    "title": "Q BLOCK MOSQUE",
    "image": "/images/projects/97.webp",
    "category": "Religious",
    "clientName": "Q BLOCK MOSQUE",
    "work": "Electrical & Allied System Design",
    "location": "Lahore",
    "area": "10,000 SFT",
    "load": "80 KW"
  }

];

export const featuredProjects = projects.filter(p => FEATURED_IDS.includes(p.id));

export const clients = [
  {
    name: "Emarsons Engineering Consultants",
    logo: "/images/clients/clinet1.webp"
  },
  {
    name: "Al Huda International",
    logo: "/images/clients/clinet2.webp"
  },
  {
    name: "Castle Shepherd Gilmour",
    logo: "/images/clients/clinet3.webp"
  },
  {
    name: "New City Arcade",
    logo: "/images/clients/clinet4.webp"
  },
  {
    name: "New City",
    logo: "/images/clients/clinet5.webp"
  },
  {
    name: "Dimensions Planning Engineering",
    logo: "/images/clients/clinet6.webp"
  },
  {
    name: "Alpha Developers",
    logo: "/images/clients/clinet7.webp"
  },
  {
    name: "Sunrise Builders",
    logo: "/images/clients/clinet8.webp"
  },
  {
    name: "Blue Sky Architects",
    logo: "/images/clients/clinet9.webp"
  },
  {
    name: "Green Valley Estates",
    logo: "/images/clients/clinet10.webp"
  },
  {
    name: "PrimeCon Developers",
    logo: "/images/clients/clinet11.webp"
  },
  {
    name: "VisionTech Consultants",
    logo: "/images/clients/clinet12.webp"
  },
  {
    name: "UrbanRise Construction",
    logo: "/images/clients/clinet13.webp"
  },
  {
    name: "Zenith Planners",
    logo: "/images/clients/clinet14.webp"
  },
  {
    name: "Evolve Builders",
    logo: "/images/clients/clinet15.webp"
  },
  {
    name: "Infinity Consultants",
    logo: "/images/clients/clinet16.webp"
  },
  {
    name: "Nexus Developers",
    logo: "/images/clients/clinet17.webp"
  },
  {
    name: "Skyline Engineers",
    logo: "/images/clients/clinet18.webp"
  },
  {
    name: "Vertex Planners",
    logo: "/images/clients/clinet19.webp"
  },
  {
    name: "Apex Designs",
    logo: "/images/clients/clinet20.webp"
  },
  {
    name: "Radiant Constructions",
    logo: "/images/clients/clinet21.webp"
  },
  {
    name: "Pinnacle Architects",
    logo: "/images/clients/clinet22.webp"
  },
  {
    name: "NextGen Builders",
    logo: "/images/clients/clinet23.webp"
  },
  {
    name: "Crescent Consultants",
    logo: "/images/clients/clinet24.webp"
  },
  {
    name: "Landmark Engineering",
    logo: "/images/clients/clinet25.webp"
  },
  {
    name: "FutureScape Developments",
    logo: "/images/clients/clinet26.webp"
  },
  {
    name: "Elevate Architecture",
    logo: "/images/clients/clinet27.webp"
  },
  {
    name: "Momentum Group",
    logo: "/images/clients/clinet28.webp"
  },
  {
    name: "NovaTech Engineers",
    logo: "/images/clients/clinet29.webp"
  },
  {
    name: "Matrix Developers",
    logo: "/images/clients/clinet30.webp"
  },
  {
    name: "BuildWise Group",
    logo: "/images/clients/clinet31.webp"
  },
  {
    name: "ModernNest Constructions",
    logo: "/images/clients/clinet32.webp"
  },
  {
    name: "Unity Engineers",
    logo: "/images/clients/clinet33.webp"
  },
  {
    name: "Metro Vision Architects",
    logo: "/images/clients/clinet34.webp"
  },
  {
    name: "SmartBuild Solutions",
    logo: "/images/clients/clinet35.webp"
  },
  {
    name: "SkyNest Estates",
    logo: "/images/clients/clinet36.webp"
  },
  {
    name: "EcoCity Developers",
    logo: "/images/clients/clinet37.webp"
  },
  {
    name: "StructurePro",
    logo: "/images/clients/clinet38.webp"
  },
  {
    name: "Architecta Designs",
    logo: "/images/clients/clinet39.webp"
  },
  {
    name: "UrbanGrid Planners",
    logo: "/images/clients/clinet40.webp"
  },
  {
    name: "AlphaCore Engineering",
    logo: "/images/clients/clinet41.webp"
  },
  {
    name: "SkyPeak Developments",
    logo: "/images/clients/clinet42.webp"
  }
];

// Add more data exports here for other sections/components as needed 
